





















import { Component, Emit, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class SearchPeople extends Vue {
  searchBy = '';

  @Emit('on-search')
  triggerSearch() {
    return this.searchBy;
  }
}
